import { TitleContainer } from './TitleContainer';

export default TitleContainer;
